/* eslint-disable no-var */

$(document).ready(function () {
    initialize();
});

let translations: any = null;

var initialize = () => {
    if (!readCookie) return;

    const isSeen = readCookie('usbSeen');
    if (!isSeen && isInternetExplorer()) {
        loadModal();
        setCookie('usbSeen', true, 1, '/', (window as any).sCookieDomain);
    }
};

var loadModal = () => {
    const script = document.createElement('script');
    script.setAttribute('type', 'text/javascript');
    script.setAttribute('src', '/assets/js/bootstrap/plugins/bootbox/bootbox.min.js');
    document.body.appendChild(script);
    $.ajax({
        type: 'GET',
        url: `/3/general/resources?lang=${readCookie('lng')}&sets=UnsupportedBrowser&includeShared=false`,
        dataType: 'json',
    })
        .done((x) => {
            translations = x;
        })
        .fail((e) => console.error('Error getting translations: ', e));
    waitForBootboxAndTranslations();
};

const timeout = 50;
var waitForBootboxAndTranslations = () => {
    if (translations && (window as any).bootbox) {
        showModal();
    } else {
        setTimeout(waitForBootboxAndTranslations, timeout * 1.5);
    }
};

var showModal = () => {
    (window as any).bootbox.dialog({
        title: `<h1>${translations.lblUnsupportedBrowser}</h1>`,
        message: `<table width="100%">
		<tr>
			<td class="content">
				<table width="100%" style="margin-top:-20px;">
					<tr>
						<td>${translations.lblUnsupportedBrowserIntro}<br><br><br></td>
					</tr>
                    <tr>
                        <td align="center" colspan="2">
                            <table width="100%" style="margin-bottom:10px;">
                                <tr>
                                    <td style="text-align: center;width:25%">
                                        <a href="http://www.google.com/chrome/" target="_blank" style="font-weight:bold;">
                                            <img src="/assets/img/browsers/chrome_128x128.png" alt="Google Chrome" style="width:64px; height:64px; margin-bottom:6px;" />
                                            <br>Chrome</a>
                                        </td>
                                    <td style="text-align:center;width:25%">
                                        <a href="http://www.apple.com/safari/" target="_blank" style="font-weight:bold;">
                                            <img src="/assets/img/browsers/safari_128x128.png" alt="Apple Safari" style="width:64px; height:64px; margin-bottom:6px;" />
                                            <br>Safari</a>
                                        </td>
                                    <td style="text-align:center;width:25%">
                                        <a href="http://www.mozilla.com/firefox/" target="_blank" style="font-weight:bold;">
                                            <img src="/assets/img/browsers/firefox_128x128.png" alt="Mozilla Firefox" style="width:64px; height:64px; margin-bottom:6px;" />
                                            <br>Firefox</a>
                                        </td>
                                    <td style="text-align:center;width:25%">
                                        <a href="https://www.microsoft.com/edge" target="_blank" style="font-weight:bold;">
                                            <img src="/assets/img/browsers/edge_128x128.png" alt="Microsoft Edge" style="width:64px; height:64px; margin-bottom:6px;" />
                                            <br>Edge</a>
                                        </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <br>
                                <br>
                                    <a href="https://www.checkmarket.com/kb/supported-browsers/" style="font-weight:bold;" target="_blank">${translations.lblMoreInfo}</a></td>
                        <td style="text-align:right">
                            <br>
                                <br>
                                    <button class="btn btn-default" onclick="bootbox.hideAll()">${translations.lblContinueAnyway}</button></td>
                            </tr>
                        </table>
                    </td>
                </tr>
            </table>`,
    });
};

var isInternetExplorer = (): boolean => {
    return /MSIE|Trident/.test(window.navigator.userAgent);
};

var readCookie: (key: string) => any = (window as any).readCookie;
var setCookie: (key: string, value: any, ttl: number, path: string, domain: string) => void = (window as any).setCookie;
